import React from "react";
import Footer from "../Footer";
import Header from "../Header";
import PageBanner from "../PageBanner";
import About from "../About/About";
import Serveices from "../About/Serveices";
import MetaTags from "react-meta-tags";

const AboutPage = () => {
  const Breadcrumb = [
    {
      title: "Domov",
    },
    {
      title: "Modulárny systém",
    },
  ];
  return (
    <>
      <MetaTags>
        <title>Sofabed Emma - Modulárny systém</title>
        <meta
          name="description"
          content="Slovenské sedačky pre každodenné spanie s výnimočným komfortom, flexibilitou a moderným dizajnom. Ideálne pre kvalitný spánok aj relaxáciu. S matracom v cene."
        />
        <meta property="og:title" content="Sofabed Emma - Modulárny systém" />
        <meta property="og:image" content="assets/Images/emma1.jpg" />
      </MetaTags>
      <Header />
      <PageBanner value={Breadcrumb} />
      <About />
      <Serveices />
      <Footer />
    </>
  );
};

export default AboutPage;
